import { filterNotEmpty } from '../../utils/listHelpers';
import { TransferListOption } from './TransferList.types';

export const shouldHideCheckbox = (search: string, label: string) =>
  !label.toLocaleLowerCase().includes(search?.toLocaleLowerCase());

export const getOptions = <VALUE extends string>(
  options: TransferListOption<VALUE>[],
  values: VALUE[],
  searchTerm?: string
) => {
  const rightOptions = filterNotEmpty(values.map((value) => options.find((option) => option.value === value)));
  const leftOptions = [...options].filter((option) => !values.includes(option.value));

  if (!searchTerm) {
    return {
      leftOptions,
      rightOptions
    };
  }
  return {
    leftOptions: leftOptions.filter((option) => !shouldHideCheckbox(searchTerm, option.label)),
    rightOptions: rightOptions.filter((option) => !shouldHideCheckbox(searchTerm, option.label))
  };
};
